import { Component } from '@angular/core';
import { Input } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'edl-modal-roster-print',
    templateUrl: './edl-modal-roster-print.component.html',
    styleUrls: ['./edl-modal-roster-print.component.scss']
})
export class EdlModalRosterPrintComponent {
    @Input() title: string ;
    @Input() message: string;

    noteForm: UntypedFormGroup;

    constructor(
        public activeModal: NgbActiveModal,
        private formBuilder: UntypedFormBuilder) { }

    ngOnInit() {
        this.noteForm = this.formBuilder.group({
            Message: [null, []]
        });
    }

    submit(mode: string) {
        this.activeModal.close(mode);
    }
}